module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap"
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "images/pg6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been a bittersweet start to the day. Austen had managed to spoil what should’ve been a nice visit with Grayson. If Austen tries to call me today, I won’t answer, I reminded myself. If he knocks at the door, I won’t let him in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the way home, I picked up the mail. My phone was ringing in my purse. When I glanced at the screen, I could see that it was Harry. I was close to home, so I waited to call him back. Once inside, I tossed my coat on the couch and dialed him up. “Harry, how’s it going?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m good. I’m sorry I didn’t get to see you at the funeral luncheon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was a lovely service, and you did a fine job. How’s Rachael?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Better. She’s going to stay with her sister for a few days. I think it’ll be good for her. I’ll keep an eye on the place and feed the animals.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a good idea for her to get away for a bit. You’re so sweet to help out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Charlie would expect it, and he would’ve done the same for me,” Harry said, sounding choked up. “It looks like an early spring,” he said, changing the subject. “Their place could get out of hand pretty easily.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is there anything I can do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can keep me company,” he teased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Harry, you know what I mean. What about the barn quilts?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rachael wants the business to stay closed for now. She mentioned that she has some orders to finish up, and that may be good for her when she returns. I think folks will be patient, considering the circumstances.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The quilt will be ready anytime for the chamber’s auction. Grayson Wills arranged it all. I hope we raise a lot of money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of Mr. Wills, you seem to fancy him these days from what I hear. Is that true?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I paused to think about my response. I didn’t want to hurt Harry’s feelings. “Well, in a way. He reached out to me as a new chamber member, which I really appreciated. I find him to be very modest, smart, and a good father who’s raising a teenager as a single parent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, and a good businessman, just like his father. Just make sure he treats you right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We aren’t that close, but I’ll keep my eyes open, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He chuckled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hung up feeling good that Rachael was being taken care of. For now, I’d have more time to paint since I wouldn’t be needed to help her at the barn. With the fundraising quilt on my mind, I decided to call Greta to find out if she’d finished quilting it. She was quick to answer the call and even quicker to get down to business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought I might hear from you any day now. Yes, it’s quilted, and I’m getting the binding on as we speak,” Greta said in her typical straightforward manner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that’s great! We have the okay from the chamber to auction it off, so I’m excited about the prospect of raising a lot of money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll bring it to club so everyone can see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wonderful! I can’t thank you enough for quilting it. It’ll mean a lot to Rachael.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wish her well. I know it’ll be hard. I’ll see you at club then,” Greta said before she hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Greta was a hard one to figure out. She was always on guard and careful not to show any emotion. She was too possessive with the quilt club, but she got by with it year after year. So many things in that club truly perplexed me, but I couldn’t think about that now. I needed to get started on my work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d just settled into painting when Ericka called.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have the day off so I’m doing some planning. I also had to meet the delivery men over at Cher’s condo. It’s too bad that her move was delayed again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. She’s so eager to get back here. I read that her new place is also a resort of some kind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it has some nice features. Living there, she’ll meet permanent residents as well as tourists. I want to throw a little welcome-home party for her when she gets here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’ll be glad to help. Do you think her quilt friends from the club will come if you invite them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d hope so!” Ericka said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rachael went to stay with her sister for a while, but if she’s back by the time you plan it, I’ll be sure to tell her about the party. I just want Cher back here. It’s time!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely!” Ericka agreed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c07552ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0004_chapter-title-008.vue
// module id = 90
// module chunks = 0